import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpApiService } from '@recruitee/http';
import {
  ReferralFilterOptions,
  ReferralOfferAssignment,
  ReferralReward,
  ReferralTemplate,
} from '@recruitee/http/types';
import { PaginationState } from '@recruitee/ngrx';

import { FilterSet } from './offer-assignments.store';

@Injectable({ providedIn: 'root' })
export class OfferAssignmentsHttpService {
  constructor(private httpApi: HttpApiService) {}

  public loadOfferAssignments(
    params: FilterSet,
  ): Observable<{
    offerAssignments: ReferralOfferAssignment[];
    references: ReferralReward[];
    meta: PaginationState;
  }> {
    return this.httpApi.get('/offers/active', params);
  }

  public loadOfferAssignmentDetails(
    offerId: number,
  ): Observable<{
    offerAssignment: ReferralOfferAssignment;
    references: (ReferralReward | ReferralTemplate)[];
  }> {
    return this.httpApi.get(`/offers/${offerId}`);
  }

  public loadOfferFilters(): Observable<ReferralFilterOptions> {
    return this.httpApi.get(`/offers/filters`);
  }
}
